<template>
    <section>

        <div v-if="this.$route.query.fromProgram" @click="$router.go(-1)" class="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="27" viewBox="0 0 11 27" fill="none">
                <path d="M9.96429 1.00012L1.03572 13.5001L9.96429 26.0001" stroke="#464D5B" />
            </svg>
            <h2>{{ capitalizeAndLowercase(classByID.title) }}</h2>
        </div>
        <div v-else-if="this.$route.query.fromCalendar" @click="$router.go(-1)" class="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="27" viewBox="0 0 11 27" fill="none">
                <path d="M9.96429 1.00012L1.03572 13.5001L9.96429 26.0001" stroke="#464D5B" />
            </svg>
            <h2>{{ capitalizeAndLowercase(classByID.title) }}</h2>
        </div>
        <div v-else @click="linkTo('clases')" class="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="27" viewBox="0 0 11 27" fill="none">
                <path d="M9.96429 1.00012L1.03572 13.5001L9.96429 26.0001" stroke="#464D5B" />
            </svg>
            <h2>{{ capitalizeAndLowercase(classByID.title) }}</h2>
        </div>
        <hr class="mov">
        <div class="errorMessage" v-if="showError">
            <p>Ocurrio un error al intentar reproducir el video en vivo. <br>
                Intenta recargar la pagina para intentarlo nuevamente.</p>
        </div>
        <video v-show="classByID.isLive === true && live && live.url" id="video" controls ref="videoPlayer"
            @loadedmetadata="onVideoLoaded">
        </video>

        <div v-show="classByID.isLive === false" class="videoCont" :class="{ 'videoPlays': playVideo === true }">

            <div id="made-in-ny"></div>

            <div :class="{ 'disNone': showVideo }" class="cover">
                <button @click="playVideo = true, showVideoIn(), playVideoNow()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="65" viewBox="0 0 37 65" fill="none">
                        <path
                            d="M2 61.9066V3.3434C2 2.46271 3.05606 2.01206 3.6919 2.62141L34.2466 31.903C34.6574 32.2967 34.6574 32.9533 34.2466 33.347L3.69191 62.6286C3.05606 63.238 2 62.7873 2 61.9066Z"
                            stroke="white" stroke-width="3" />
                    </svg>
                </button>
                <img v-if="!classByID.image" src="../../assets/videoTemp.jpg" alt="">
                <img v-else :src="srcImg(classByID.image)" alt="">
            </div>
        </div>
        <div class="information">
            <div class="mainInfo">

                <div class="endedClass" v-if="claseProgresById.completedAt">
                    <div class="icon"> <svg xmlns="http://www.w3.org/2000/svg" width="34" height="40"
                            viewBox="0 0 34 40" fill="none">
                            <path
                                d="M23.2092 31.6589V27.8319H10.7887V31.6589H23.2092ZM23.2092 31.6589H13.1511V33.4657C13.1511 34.4943 13.9859 35.3291 15.0145 35.3291H23.2092V31.6589ZM15.2957 9.58141C14.1123 9.58141 13.1511 10.5404 13.1511 11.726V12.2359C13.1511 13.0184 13.5478 13.7528 14.2147 14.1604C14.801 14.52 15.1933 15.1651 15.1933 15.9039C15.1933 16.6405 14.801 17.2878 14.2147 17.6474C13.5478 18.055 13.1511 18.7895 13.1511 19.5719V27.834H23.2092V22.8541C23.2092 21.7927 24.0482 20.9275 25.0987 20.8817V19.5719C25.0987 18.7895 24.7021 18.055 24.0352 17.6474C23.4489 17.2878 23.0566 16.6427 23.0566 15.9039C23.0566 15.1651 23.4489 14.5178 24.0352 14.1604C24.7021 13.7528 25.0987 13.0184 25.0987 12.2359V11.726C25.0987 10.5425 24.1398 9.58141 22.9542 9.58141H15.2957ZM15.2957 9.58141V8.11902C15.2957 7.5284 15.773 7.0511 16.3636 7.0511H21.8863C22.4769 7.0511 22.9563 7.53058 22.9563 8.11902V9.58141L15.2957 9.58141ZM13.21 19.2951H25.029M8.74436 38.5001C7.61542 38.5001 6.70006 37.5848 6.70006 36.4558V22.9195C6.70006 21.7905 7.61542 20.8752 8.74436 20.8752C9.8733 20.8752 10.7887 21.7905 10.7887 22.9195V36.4558C10.7887 37.5848 9.8733 38.5001 8.74436 38.5001ZM5.09819 35.1373C4.21334 35.1373 3.49632 34.4203 3.49632 33.5354V25.8399C3.49632 24.955 4.21334 24.238 5.09819 24.238C5.98303 24.238 6.70006 24.955 6.70006 25.8399V33.5354C6.70006 34.4203 5.98303 35.1373 5.09819 35.1373ZM25.2535 20.8752C26.3824 20.8752 27.2978 21.7905 27.2978 22.9195V36.4558C27.2978 37.5848 26.3824 38.5001 25.2535 38.5001C24.1245 38.5001 23.2092 37.5848 23.2092 36.4558V22.9195C23.2092 21.7905 24.1245 20.8752 25.2535 20.8752ZM28.8996 24.238C29.7845 24.238 30.5015 24.955 30.5015 25.8399V33.5354C30.5015 34.4203 29.7845 35.1373 28.8996 35.1373C28.0148 35.1373 27.2978 34.4203 27.2978 33.5354V25.8399C27.2978 24.955 28.0148 24.238 28.8996 24.238ZM1.54573 27.8319C1.24933 27.8319 1.0096 28.0716 1.0096 28.368V31.125C1.0096 31.4214 1.24933 31.6611 1.54573 31.6611H3.49849V27.8319H1.54573ZM32.4543 27.8319H30.5015V31.6589H32.4543C32.7507 31.6589 32.9904 31.4192 32.9904 31.1228V28.3658C32.9882 28.0716 32.7485 27.8319 32.4543 27.8319ZM17 4.41618H21.252V7.0511H17V4.41618ZM19.4257 1.50012H18.8242C17.3226 1.50012 16.1043 2.71842 16.1043 4.22004V4.41618H22.1478V4.22004C22.1478 2.71842 20.9295 1.50012 19.4257 1.50012Z"
                                stroke="url(#paint0_linear_4911_8744)" stroke-width="2" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <defs>
                                <linearGradient id="paint0_linear_4911_8744" x1="1.0096" y1="20.0001" x2="32.9904"
                                    y2="20.0001" gradientUnits="userSpaceOnUse">
                                    <stop offset="0.23516" stop-color="#4536EF" />
                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                </linearGradient>
                            </defs>
                        </svg></div>
                    <p>Clase completada</p>
                    <span>{{ formatDate(claseProgresById.completedAt) }}</span>
                    <span>{{ formatHour(claseProgresById.completedAt) }}</span>
                </div>
                <div class="moreInfo row">
                    <h5>Sobre la clase</h5>
                    <p>{{ classByID.descr }}</p>
                </div>
                <div class="moreInfo">
                    <h5>Información</h5>
                    <div class="classAtributes">
                        <div class="atribute">
                            <span>Clase:</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                    fill="url(#paint0_linear_1426_5347)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                        y2="9.00012" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ capitalizeAndLowercase(classByID.title) }}</p>

                        </div>
                        <hr>
                        <template v-if="classByID.method">
                            <div class="atribute">
                                <span>Método:</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                    fill="none">
                                    <path
                                        d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                        fill="url(#paint0_linear_1426_5347)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                            y2="9.00012" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FFE711" />
                                            <stop offset="1" stop-color="#96FF11" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p>{{ classByID.method }}</p>
                            </div>
                            <hr>
                        </template>
                        <div class="atribute">
                            <span>Duración:</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                    fill="url(#paint0_linear_1426_5347)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                        y2="9.00012" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ Math.floor(classByID.duration / 60) }}:{{ (classByID.duration %
                                60).toString().padStart(2,
                                    '0') }} min</p>
                        </div>
                        <hr>
                        <div class="atribute">
                            <span>Intensidad:</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                    fill="url(#paint0_linear_1426_5347)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                        y2="9.00012" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <div class="claseDificulty">
                                <template v-if="classByID.intensity === 'Baja'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                                <template v-if="classByID.intensity === 'Media'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                        viewBox="0 0 12 13" fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                                <template v-if="classByID.intensity === 'Alta'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                        fill="none">
                                        <path
                                            d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                            fill="url(#paint0_linear_3899_5474)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                <stop offset="0.23516" stop-color="#4536EF" />
                                                <stop offset="0.913242" stop-color="#FF00B8" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </template>
                            </div>
                            <p>{{ classByID.intensity }}</p>


                        </div>
                        <hr>
                        <div class="atribute">
                            <span>Fecha:</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                fill="none">
                                <path
                                    d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                    fill="url(#paint0_linear_1426_5347)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                        y2="9.00012" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FFE711" />
                                        <stop offset="1" stop-color="#96FF11" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <p>{{ formatDate(classByID.publishDate) }}</p>
                        </div>
                        <template v-if="classByID.equipment">
                            <hr>
                            <div class="atribute">
                                <span>Equipamiento</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18"
                                    fill="none">
                                    <path
                                        d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                                        fill="url(#paint0_linear_1426_5347)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5347" x1="15" y1="9.00012" x2="0"
                                            y2="9.00012" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FFE711" />
                                            <stop offset="1" stop-color="#96FF11" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p class="fitW" v-for="(equipo, index) in classByID.equipment">
                                    {{ equipo.name }}<span v-if="index < classByID.equipment.length - 1">, </span><span
                                        v-else>.</span>
                                </p>
                            </div>
                        </template>
                        <template v-else>

                        </template>
                    </div>
                </div>
                <!-- <h5>Clases relacionadas</h5>
                <div class="related">
                    <div class="relatedCard" v-for="n in 4"></div>
                </div> -->
            </div>
            <div class="asideInfo">
                <div class="header">
                    <h5>Comentarios</h5>
                    <button @click="openCommentModal()" class="leaveComment">
                        <p>Dejar comentario</p>
                    </button>
                </div>

                <div v-for="comentario in comentarios.data" class="comentarioCont">
                    <div class="comentario">
                        <div class="comentarioInfo">
                            <div class="user">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17"
                                    fill="none">
                                    <path
                                        d="M7.5 0.00012207C8.47633 0.00012207 8.9645 0.69733 8.9645 2.09174C8.9645 2.71478 8.90532 3.44166 8.78698 4.27237L8.60947 5.42944C8.5503 5.9338 8.50592 6.24532 8.47633 6.364L8.38757 6.94253L10.5178 5.25143C11.9083 4.12403 12.9142 3.56033 13.5355 3.56033C14.1568 3.56033 14.5858 3.79768 14.8225 4.27237C14.9408 4.45038 15 4.65806 15 4.89541C15 5.54812 14.6598 6.08215 13.9793 6.49751C13.3284 6.88319 12.4408 7.28372 11.3166 7.69907L9.31953 8.50012L11.8047 9.47918C12.6923 9.8352 13.3432 10.1467 13.7574 10.4137C14.5858 10.8588 15 11.4225 15 12.1048C15 12.3125 14.8964 12.5944 14.6893 12.9504C14.5118 13.2767 14.1272 13.4399 13.5355 13.4399C12.9438 13.4399 11.9379 12.8762 10.5178 11.7488L8.38757 10.0577L8.47633 10.7253C8.47633 10.8736 8.52071 11.1703 8.60947 11.6153L8.87574 13.1729C8.93491 13.7663 8.9645 14.3596 8.9645 14.953C8.9645 15.5167 8.83136 16.0062 8.56509 16.4216C8.3284 16.8073 7.97337 17.0001 7.5 17.0001C7.02663 17.0001 6.65681 16.8073 6.39053 16.4216C6.15385 16.0062 6.0355 15.5019 6.0355 14.9085C6.0355 14.2855 6.09468 13.5586 6.21302 12.7279L6.39053 11.5708C6.4497 11.0664 6.49408 10.7549 6.52367 10.6362L6.61243 10.0577L4.48225 11.7488C3.09172 12.8762 2.0858 13.4399 1.4645 13.4399C0.843195 13.4399 0.414201 13.2026 0.177515 12.7279C0.0591716 12.5499 0 12.3422 0 12.1048C0 11.4521 0.325444 10.9329 0.976331 10.5472C1.6568 10.1319 2.55917 9.71653 3.68343 9.30117L5.68047 8.50012L3.19527 7.52107C2.33728 7.19471 1.6716 6.88319 1.19822 6.58651C0.399408 6.11182 0 5.54812 0 4.89541C0 4.68773 0.0887574 4.42072 0.266272 4.09436C0.473373 3.73834 0.798816 3.56033 1.2426 3.56033C1.71598 3.56033 2.18935 3.70867 2.66272 4.00536C3.13609 4.27237 3.7426 4.68773 4.48225 5.25143L6.61243 6.94253L6.52367 6.27499C6.52367 6.12665 6.47929 5.82996 6.39053 5.38494L6.12426 3.82735C6.06509 3.23398 6.0355 2.64061 6.0355 2.04724C6.0355 1.42421 6.15385 0.934677 6.39053 0.578657C6.65681 0.192967 7.02663 0.00012207 7.5 0.00012207Z"
                                        fill="url(#paint0_linear_1426_5194)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5194" x1="15" y1="8.50012" x2="0"
                                            y2="8.50012" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FFE711" />
                                            <stop offset="1" stop-color="#96FF11" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p>{{ comentario.user.name }}</p>
                            </div>
                            <span>{{ formatDate(comentario.createdAt) }}</span>
                        </div>
                        <p>{{ comentario.message }}</p>
                        <div class="comentarioActions">
                            <!-- <button class="like">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21"
                                    fill="none">
                                    <mask id="mask0_1426_5199" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                        y="0" width="20" height="21">
                                        <rect y="0.500122" width="20" height="20" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1426_5199)">
                                        <path
                                            d="M10 17.4391L9.08022 16.6122C7.69883 15.359 6.55647 14.2821 5.65314 13.3816C4.7498 12.4809 4.03397 11.6793 3.50564 10.9768C2.9773 10.2744 2.6082 9.63366 2.39834 9.05449C2.18834 8.47546 2.08334 7.88789 2.08334 7.29178C2.08334 6.10914 2.48209 5.119 3.27959 4.32136C4.07723 3.52386 5.06737 3.12511 6.25001 3.12511C6.97751 3.12511 7.66501 3.29525 8.31251 3.63553C8.96001 3.97581 9.52251 4.4638 10 5.09949C10.4775 4.4638 11.04 3.97581 11.6875 3.63553C12.335 3.29525 13.0225 3.12511 13.75 3.12511C14.9326 3.12511 15.9228 3.52386 16.7204 4.32136C17.5179 5.119 17.9167 6.10914 17.9167 7.29178C17.9167 7.88789 17.8117 8.47546 17.6017 9.05449C17.3918 9.63366 17.0227 10.2744 16.4944 10.9768C15.9661 11.6793 15.2515 12.4809 14.3508 13.3816C13.4503 14.2821 12.3066 15.359 10.9198 16.6122L10 17.4391ZM10 15.7501C11.3333 14.5504 12.4306 13.5221 13.2917 12.6651C14.1528 11.8083 14.8333 11.0639 15.3333 10.432C15.8333 9.80005 16.1806 9.23886 16.375 8.74845C16.5695 8.25817 16.6667 7.77261 16.6667 7.29178C16.6667 6.45845 16.3889 5.764 15.8333 5.20845C15.2778 4.65289 14.5833 4.37511 13.75 4.37511C13.092 4.37511 12.4838 4.56178 11.9254 4.93511C11.3672 5.30859 10.9252 5.8281 10.5994 6.49366H9.40064C9.06939 5.82268 8.62598 5.30185 8.07043 4.93116C7.51487 4.56046 6.90807 4.37511 6.25001 4.37511C5.42195 4.37511 4.72883 4.65289 4.17064 5.20845C3.61244 5.764 3.33334 6.45845 3.33334 7.29178C3.33334 7.77261 3.43057 8.25817 3.62501 8.74845C3.81945 9.23886 4.16668 9.80005 4.66668 10.432C5.16668 11.0639 5.84723 11.807 6.70834 12.6612C7.56945 13.5153 8.66668 14.545 10 15.7501Z"
                                            fill="url(#paint0_linear_1426_5199)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5199" x1="2.08334" y1="10.2821"
                                            x2="17.9167" y2="10.2821" gradientUnits="userSpaceOnUse">
                                            <stop offset="0.23516" stop-color="#4536EF" />
                                            <stop offset="0.913242" stop-color="#FF00B8" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button> -->
                            <button class="answer" @click="openCommentModal(comentario.id)">
                                <p>Responder</p>
                            </button>
                        </div>
                    </div>
                    <div v-for="replie in comentario.replies" class="respuesta">
                        <div class="decoLine"></div>
                        <div class="comentarioInfo">
                            <div class="user">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17"
                                    fill="none">
                                    <path
                                        d="M7.5 0.00012207C8.47633 0.00012207 8.9645 0.69733 8.9645 2.09174C8.9645 2.71478 8.90532 3.44166 8.78698 4.27237L8.60947 5.42944C8.5503 5.9338 8.50592 6.24532 8.47633 6.364L8.38757 6.94253L10.5178 5.25143C11.9083 4.12403 12.9142 3.56033 13.5355 3.56033C14.1568 3.56033 14.5858 3.79768 14.8225 4.27237C14.9408 4.45038 15 4.65806 15 4.89541C15 5.54812 14.6598 6.08215 13.9793 6.49751C13.3284 6.88319 12.4408 7.28372 11.3166 7.69907L9.31953 8.50012L11.8047 9.47918C12.6923 9.8352 13.3432 10.1467 13.7574 10.4137C14.5858 10.8588 15 11.4225 15 12.1048C15 12.3125 14.8964 12.5944 14.6893 12.9504C14.5118 13.2767 14.1272 13.4399 13.5355 13.4399C12.9438 13.4399 11.9379 12.8762 10.5178 11.7488L8.38757 10.0577L8.47633 10.7253C8.47633 10.8736 8.52071 11.1703 8.60947 11.6153L8.87574 13.1729C8.93491 13.7663 8.9645 14.3596 8.9645 14.953C8.9645 15.5167 8.83136 16.0062 8.56509 16.4216C8.3284 16.8073 7.97337 17.0001 7.5 17.0001C7.02663 17.0001 6.65681 16.8073 6.39053 16.4216C6.15385 16.0062 6.0355 15.5019 6.0355 14.9085C6.0355 14.2855 6.09468 13.5586 6.21302 12.7279L6.39053 11.5708C6.4497 11.0664 6.49408 10.7549 6.52367 10.6362L6.61243 10.0577L4.48225 11.7488C3.09172 12.8762 2.0858 13.4399 1.4645 13.4399C0.843195 13.4399 0.414201 13.2026 0.177515 12.7279C0.0591716 12.5499 0 12.3422 0 12.1048C0 11.4521 0.325444 10.9329 0.976331 10.5472C1.6568 10.1319 2.55917 9.71653 3.68343 9.30117L5.68047 8.50012L3.19527 7.52107C2.33728 7.19471 1.6716 6.88319 1.19822 6.58651C0.399408 6.11182 0 5.54812 0 4.89541C0 4.68773 0.0887574 4.42072 0.266272 4.09436C0.473373 3.73834 0.798816 3.56033 1.2426 3.56033C1.71598 3.56033 2.18935 3.70867 2.66272 4.00536C3.13609 4.27237 3.7426 4.68773 4.48225 5.25143L6.61243 6.94253L6.52367 6.27499C6.52367 6.12665 6.47929 5.82996 6.39053 5.38494L6.12426 3.82735C6.06509 3.23398 6.0355 2.64061 6.0355 2.04724C6.0355 1.42421 6.15385 0.934677 6.39053 0.578657C6.65681 0.192967 7.02663 0.00012207 7.5 0.00012207Z"
                                        fill="url(#paint0_linear_1426_5194)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5194" x1="15" y1="8.50012" x2="0"
                                            y2="8.50012" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#FFE711" />
                                            <stop offset="1" stop-color="#96FF11" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p>{{ replie.user.name }}</p>
                            </div>
                            <span>{{ formatDate(replie.createdAt) }}</span>
                        </div>
                        <p>{{ replie.message }}</p>
                        <div class="comentarioActions">
                            <!-- <button class="like">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21"
                                    fill="none">
                                    <mask id="mask0_1426_5199" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                        y="0" width="20" height="21">
                                        <rect y="0.500122" width="20" height="20" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1426_5199)">
                                        <path
                                            d="M10 17.4391L9.08022 16.6122C7.69883 15.359 6.55647 14.2821 5.65314 13.3816C4.7498 12.4809 4.03397 11.6793 3.50564 10.9768C2.9773 10.2744 2.6082 9.63366 2.39834 9.05449C2.18834 8.47546 2.08334 7.88789 2.08334 7.29178C2.08334 6.10914 2.48209 5.119 3.27959 4.32136C4.07723 3.52386 5.06737 3.12511 6.25001 3.12511C6.97751 3.12511 7.66501 3.29525 8.31251 3.63553C8.96001 3.97581 9.52251 4.4638 10 5.09949C10.4775 4.4638 11.04 3.97581 11.6875 3.63553C12.335 3.29525 13.0225 3.12511 13.75 3.12511C14.9326 3.12511 15.9228 3.52386 16.7204 4.32136C17.5179 5.119 17.9167 6.10914 17.9167 7.29178C17.9167 7.88789 17.8117 8.47546 17.6017 9.05449C17.3918 9.63366 17.0227 10.2744 16.4944 10.9768C15.9661 11.6793 15.2515 12.4809 14.3508 13.3816C13.4503 14.2821 12.3066 15.359 10.9198 16.6122L10 17.4391ZM10 15.7501C11.3333 14.5504 12.4306 13.5221 13.2917 12.6651C14.1528 11.8083 14.8333 11.0639 15.3333 10.432C15.8333 9.80005 16.1806 9.23886 16.375 8.74845C16.5695 8.25817 16.6667 7.77261 16.6667 7.29178C16.6667 6.45845 16.3889 5.764 15.8333 5.20845C15.2778 4.65289 14.5833 4.37511 13.75 4.37511C13.092 4.37511 12.4838 4.56178 11.9254 4.93511C11.3672 5.30859 10.9252 5.8281 10.5994 6.49366H9.40064C9.06939 5.82268 8.62598 5.30185 8.07043 4.93116C7.51487 4.56046 6.90807 4.37511 6.25001 4.37511C5.42195 4.37511 4.72883 4.65289 4.17064 5.20845C3.61244 5.764 3.33334 6.45845 3.33334 7.29178C3.33334 7.77261 3.43057 8.25817 3.62501 8.74845C3.81945 9.23886 4.16668 9.80005 4.66668 10.432C5.16668 11.0639 5.84723 11.807 6.70834 12.6612C7.56945 13.5153 8.66668 14.545 10 15.7501Z"
                                            fill="url(#paint0_linear_1426_5199)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_1426_5199" x1="2.08334" y1="10.2821"
                                            x2="17.9167" y2="10.2821" gradientUnits="userSpaceOnUse">
                                            <stop offset="0.23516" stop-color="#4536EF" />
                                            <stop offset="0.913242" stop-color="#FF00B8" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button> -->
                            <!-- <button class="answer">
                                <p>Responder</p>
                            </button> -->
                        </div>
                    </div>
                </div>


                <template v-if="comentarios.data">
                    <div class="template" v-if="!comentarios.data.length > 0">
                        <p>Aun no hay comentarios</p>
                    </div>
                    <div class="bottom" v-else>
                        <button class="moreComments">
                            <p>Ver más comentarios</p>
                        </button>
                        <button @click="openCommentModal()" class="leaveComment">
                            <p>Dejar comentario</p>
                        </button>
                    </div>
                </template>
                <template v-else></template>
            </div>
        </div>
        <CommentModal :isOpen="isCommentModalOpen" @update:isOpen="isCommentModalOpen = $event"
            @comment-submitted="addComment" />
        <notificacion :tipo="toastType" :titulo="toastTitle" :text="toastSub" :state="toastState" />



    </section>
</template>


<script>
import CommentModal from "../commentModal.vue";
import { mapActions } from 'vuex';
import { url } from '../../global/index';
import dayjs from "dayjs";
import Notificacion from "@/components/utils/notificacion.vue";
import Hls from 'hls.js';

export default {
    name: "App",
    data() {
        return {
            hls: null,
            linkVideo: null,
            playVideo: false,
            videoReady: false,

            showVideo: false,
            player: null,
            currentTime: undefined,
            intervalId: null,
            timeSavedInLocal: null,
            endedVideo: false,
            dayPlanId: null,
            programSessionId: null,
            isCommentModalOpen: false,

            page: 1,
            pageSize: 100,
            entityId: null,
            type: 'fitnessClass',
            parentId: undefined,


            toastState: false,
            toastType: '',
            toastTitle: '',
            toastSub: '',
            fitnessClassId: null,
            showError: false,
        };
    },
    components: {
        CommentModal,
        Notificacion

    },
    async created() {

        let id = this.$route.query.id
        this.fitnessClassId = Number(this.$route.query.id);
        this.programSessionId = this.$route.query.sessionId ? Number(this.$route.query.sessionId) : null;

        const data = JSON.parse(localStorage.getItem('dataToSend'));
        localStorage.removeItem('s');

        if (data) {
            await this.$store.dispatch('progresclass/editItemPgc', {
                option: "class-progress",
                item: data,
            });

            this.currentTime = structuredClone(data.stayedAt);
            this.timeSavedInLocal = structuredClone(data.stayedAt);
        }

        if (this.$route.query.fromProgram) {
            id = `${id}?fromProgram=${this.$route.query.fromProgram}`
        }
        if (this.$route.query.fromCalendar) {
            id = `${id}?fromCalendar=${this.$route.query.fromCalendar}`
        }

        await this.getInfoByIdLgo({
            id,
            option: 'class'
        })

        const url = `class-progress?fitnessClassId=${this.fitnessClassId}${this.programSessionId ? `&programSessionId=${this.programSessionId}` : ''}`;
        await this.getAllInfoPgc(url)
        this.claseProgresById;
        this.ConstructVideo()
        this.updateComments()
    },

    beforeDestroy() {
        this.saveTime()
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        if (this.hls) {
            this.hls.destroy();
        }
    },

    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        let id = this.$route.query.id
        this.initializePlayer();

    },

    computed: {
        classByID() {
            const data = this.$store.getters['logo/data'];
            return data;
        },
        videoUrl() {
            const data = this.$store.getters['proclass/data'];
            return data;
        },
        claseProgresById() {
            const data = this.$store.getters['progresclass/data'];
            return data;
        },
        comentarios() {
            return this.$store.getters['comments/data'];
        },
        live() {
            return this.$store.getters["live/data"];
        },
    },
    methods: {
        ...mapActions("comments", ["getAllInfoCmt", "addItemCmt", "deleteItemCmt"]),
        ...mapActions('logo', ['getInfoByIdLgo']),
        ...mapActions('proclass', ['getInfoByIdPrc']),
        ...mapActions('progresclass', ['editItemPgc', 'getAllInfoPgc']),
        initializePlayer() {
            if (this.live) {
                if (this.live.id != this.$route.query.id) {
                    console.warn('Live ID does not match route ID', this.$route.query.id, this.live.id);
                    return;
                }
            }


            const video = this.$refs.videoPlayer;

            // Validar que exista el elemento video y la URL
            if (!video || !this.live || !this.live.url) {
                console.warn('Video element or URL not ready');
                return;
            }

            try {
                if (Hls.isSupported()) {
                    const config = {
                        xhrSetup: (xhr) => {
                            xhr.withCredentials = true;
                        },
                        debug: false
                    };

                    if (this.hls) {
                        this.hls.destroy();
                    }

                    this.hls = new Hls(config);

                    // Validar que la URL sea válida
                    if (typeof this.live.url !== 'string' || !this.live.url.trim()) {
                        console.error('Invalid streaming URL');
                        return;
                    }

                    this.hls.loadSource(this.live.url);
                    this.hls.attachMedia(video);

                    this.hls.on(Hls.Events.ERROR, (event, data) => {
                        console.log('HLS Error:', data);
                        this.showError = true; // Activar variable para mostrar error al usuario
                        if (data.fatal) {
                            switch (data.type) {
                                case Hls.ErrorTypes.NETWORK_ERROR:
                                    console.error('Error de red:', data);
                                    this.hls.startLoad();
                                    break;
                                case Hls.ErrorTypes.MEDIA_ERROR:
                                    console.error('Error de medio:', data);
                                    this.hls.recoverMediaError();
                                    break;
                                default:
                                    console.error('Error fatal:', data);
                                    this.destroyPlayer();
                                    break;
                            }
                        }
                    });

                    this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        if (this.videoReady) {
                            this.playVideoFunction();
                        }
                    });

                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = this.live.url;
                }
            } catch (error) {
                console.error('Error initializing player:', error);
            }
        },

        onVideoLoaded() {
            this.videoReady = true;
            this.playVideoFunction();
        },

        playVideoFunction() {
            const video = this.$refs.videoPlayer;
            if (video) {
                video.play().catch(error => {
                    console.warn('Error al reproducir:', error);
                });
            }
        },

        destroyPlayer() {
            if (this.hls) {
                this.hls.destroy();
                this.hls = null;
            }
        },
        formatDate(date) {
            return dayjs(date).format('DD/MM/YYYY');
        },
        formatHour(date) {
            return dayjs(date).format('hh:mm A');
        },
        async updateComments() {
            await this.getAllInfoCmt(`comment/paginated?page=${this.page}&pageSize=${this.pageSize}&type=${this.type}&entityId=${this.$route.query.id}`);
        },

        async handleBeforeUnload() {
            const data = {
                stayedAt: this.currentTime,
                fitnessClassId: this.fitnessClassId,
                completed: this.endedVideo,
                dayPlanId: null,
                programSessionId: this.programSessionId,
            };

            localStorage.setItem('dataToSend', JSON.stringify(data));
        },

        async sendData() {
            const data = {
                fitnessClassId: this.fitnessClassId,
                completed: this.endedVideo,
                stayedAt: this.currentTime,
                dayPlanId: null,
                programSessionId: this.programSessionId,
            };

            try {
                const response = await this.$store.dispatch('progresclass/editItemPgc', {
                    option: "class-progress",
                    item: data,
                });
                if (!response.success) throw response
            } catch (error) {
                console.log("error")
                console.log(error.message)
            }
        },
        capitalizeAndLowercase(str) {
            if (!str) return ''; // Verifica que el string no sea nulo o vacío

            // Busca la primera letra alfabética
            const firstAlphaIndex = [...str].findIndex(char => /[a-zA-Z]/.test(char));

            if (firstAlphaIndex === -1) return str.toLowerCase(); // No hay letras, solo convierte todo a minúsculas

            // Construye el nuevo string
            return (
                str.slice(0, firstAlphaIndex) + // Parte inicial, incluyendo símbolos
                str[firstAlphaIndex].toUpperCase() + // Primera letra alfabética en mayúscula
                str.slice(firstAlphaIndex + 1).toLowerCase() // Resto en minúscula
            );
        },

        linkTo(enlace) {
            const query = enlace;
            if (query) {
                const currentQuery = this.$route.query.a;

                // Verifica si la búsqueda actual es la misma que la nueva búsqueda
                if (query !== currentQuery) {
                    this.$router.push({ path: '/web-app', query: { a: query } });

                } else {
                }
            } else {
            }
        },
        srcImg: function (img) {
            if (!img || img == "") {
                return "";
            }
            let src = `${url}/class-image/${img}`;

            return src;
        },
        showVideoIn() {
            setTimeout(() => {
                this.showVideo = true
            }, "1000")
        },
        ConstructVideo() {
            let options = {
                id: this.classByID.videoId,
                height: '720',
                loop: false,
                chromecast: true, // Habilitar Chromecast
                airplay: true // Habilitar AirPlay
            };

            this.player = new Vimeo.Player('made-in-ny', options);

            this.player.setVolume(0.5);


            this.player.on('play', function () {
                this.saveTime();
            });

            this.player.setColor('#B359F8').then(function (color) {
                // color was successfully set
            }).catch(function (error) {
                switch (error.name) {

                    case 'TypeError':
                        // the string was not a valid hex or rgb color
                        break;

                    case 'EmbedSettingsError':
                        // the owner of the video has chosen to use a specific color
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });

            const updateTime = (data) => {
                this.currentTime = data.seconds;
            };

            this.player.on('timeupdate', updateTime);

            this.player.on('pause', () => {
                this.saveTimeFast()
                this.stopInterval()
                this.sendData()

            });

            this.player.on('ended', () => {
                this.videoHasEnded()
                this.stopInterval()
            });

            // Guardar el callback para poder removerlo más tarde si es necesario
            this.updateTimeCallback = updateTime;

            if (this.claseProgresById.stayedAt) {
                this.player.setCurrentTime(this.claseProgresById.stayedAt).then(function (seconds) {
                    // seconds = the actual time that the player seeked to
                }).catch(function (error) {
                    switch (error.name) {
                        case 'RangeError':
                            // the time was less than 0 or greater than the video’s duration
                            break;

                        default:
                            // some other error occurred
                            break;
                    }
                });
            }
        },
        getActualTime() {
            this.player.getCurrentTime().then(function (seconds) {
            }).catch(function (error) {
                // an error occurred
            });
        },
        removeTimeUpdateListener() {
            if (this.player && this.updateTimeCallback) {
                this.player.off('timeupdate', this.updateTimeCallback);
            }
        },
        playVideoNow() {
            this.saveTime()
            this.player.play().then(() => {
                // the video was played
            }).catch((error) => {
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;
                    case 'PrivacyError':
                        // the video is private
                        break;
                    default:
                        // some other error occurred
                        break;
                }
            });
        },
        saveTime() {
            this.timeSavedInLocal = this.currentTime
            this.sendData()
        },

        saveTimeFast() {
            this.timeSavedInLocal = this.currentTime

        },
        videoHasEnded() {
            this.endedVideo = true;
            setTimeout(() => {
                this.sendData()
            }, 50);
        },

        stopInterval() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        formatDate(dateString) {
            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            return new Date(dateString).toLocaleDateString('es-ES', options);
        },
        openCommentModal(id = undefined) {
            this.isCommentModalOpen = true;
            this.parentId = id
        },
        async addComment(newComment) {
            if (!newComment.comment) return
            const response = await this.addItemCmt({
                option: this.parentId === undefined ? 'comment' : 'comment-reply',
                item: {
                    message: newComment.comment,
                    entityId: this.$route.query.id,
                    type: this.type,
                    parentId: this.parentId !== undefined ? this.parentId : undefined
                }
            })

            if (!response.success) {
                this.parentId = null
                this.setNoti(true, 'Error', 'ERROR', response.message)
                return
            }

            this.setNoti(true, 'Success', 'Comentario creado con éxito', 'Tu comentario fue enviado a aprobación')
            await this.updateComments()
        },
        setNoti(toastState, toastType, toastTitle, toastSub) {
            this.toastState = toastState
            this.toastType = toastType
            this.toastTitle = toastTitle
            this.toastSub = toastSub
            setTimeout(() => {
                this.clearToast();
            }, 5000);
        },

        clearToast() {
            this.toastState = false
        },
    },
    watch: {
        'live.url': {
            handler(newUrl) {
                if (this.live && newUrl) {
                    this.$nextTick(() => {
                        this.initializePlayer();
                    });
                }
            },
            immediate: true
        }
    }

}
</script>

<style scoped>
section {
    padding: 0 !important;
}

.goBack {
    display: flex;
    flex-direction: row;
    gap: .555556vw;
    align-items: center;
    cursor: pointer;
}

.goBack svg {
    width: .620069vw;
    height: 1.736111vw;
    flex-shrink: 0;
}

.goBack h2 {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    align-self: stretch;
}

.videoCont {
    width: 93vw;
    height: 23.541667vw;
    border-radius: 1.388889vw;
    background-color: #E3E3E9;
    overflow: clip;
    position: relative;
    transition: height 500ms ease;
    align-self: center;
}

.videoCont #made-in-ny {
    position: absolute;
    width: 100%;
    height: 100%
}

.videoPlays .cover {
    opacity: 0;
}

.videoPlays {
    height: 45rem;
}

.cover {
    height: 100%;
    width: 100%;
    position: absolute;
    overflow: hidden;
    opacity: 1;
    transition: all 300ms ease;
}

.cover button {
    width: 2.291667vw;
    height: 4.392361vw;
    position: absolute;
    z-index: 5;
    left: 50%;
    top: 50%;
    margin-left: -1.145833vw;
    margin-top: -2.196181vw;
}

.cover img {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    filter: brightness(0.9);
}

.information {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 3.472222vw;
}

.mainInfo {
    width: 37.291667vw;
    display: flex;
    flex-direction: column;
    gap: 1.388889vw;
}

.mainInfo .moreInfo {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.mainInfo .moreInfo h5 {
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;
}

.mainInfo .moreInfo p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 21vw;
}

h5 {
    color: var(--Text, #464D5B);

    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

}

.classAtributes {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.atribute {
    display: flex;
    flex-direction: row;
    gap: .694444vw;
    align-items: center;
}

.atribute svg {
    width: 1.041667vw;
    height: 1.180556vw;
}

.atribute span {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 8.333333vw;
}

hr {
    border: #E3E3E9 solid .069444vw;
}

.claseDificulty {
    display: flex;
    gap: .208333vw;
    flex-direction: row;
}

.claseDificulty svg {
    width: .763889vw;
    height: .902778vw;
}

.disabled {
    filter: contrast(0);
}

.related {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.388889vw;

}

.relatedCard {
    min-width: 17.427083vw;
    min-height: 17.361111vw;
    background-color: #f4f6fa;
    border-radius: 1.388889vw;
}

.asideInfo {
    width: 55.069444vw;
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.asideInfo .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center
}

.asideInfo .bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center
}

.leaveComment {
    padding: .694444vw 1.388889vw;
    background-color: #B359F8;
    border-radius: 1.388889vw;
}

.leaveComment {
    color: #FFF;
    text-align: center;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.moreComments p {
    color: var(--purple, #B359F8);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.comentarioCont {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.comentario {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
    padding: 1.041667vw;

    border-radius: 2.083333vw;
    border: .013889vw solid var(--background-gray, #E3E3E9);
    background: #FFF;
    width: 55.069444vw;
}

.comentario>p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.comentarioInfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.comentarioInfo>span {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.user {
    display: flex;
    flex-direction: row;
    gap: .694444vw;
}

.user svg {
    width: 1.041667vw;
    height: 1.180556vw;
    flex-shrink: 0;
}

.user p {
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;
}

.comentarioActions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center
}

.like {
    width: 1.388889vw;
    height: 1.388889vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.like svg {
    width: 1.388889vw;
    height: 1.388889vw;
}

.answer p {
    color: var(--purple, #B359F8);
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.respuesta {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
    padding: 1.041667vw;

    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: #FFF;
    width: 95%;
    align-self: flex-end;
    position: relative;
}

.respuesta>p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.decoLine {
    position: absolute;
    height: 125%;
    width: 5.4%;
    background-color: transparent;
    left: -5.4%;
    top: -50.4%;
    border-bottom: solid #E3E3E9 .069444vw;
    border-left: solid #E3E3E9 .069444vw;
    border-radius: 0 0 0 1.388889vw;
}

#made-in-ny {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

}

.disNone {
    display: none;
}

.endedClass {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.388889vw;
    padding: .694444vw;
    border-radius: 1.388889vw;
    border: .069444vw solid #96FF11;
}

.endedClass .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.166667vw;
    height: 4.166667vw;
    border: #4536EF solid .069444vw;
    border-radius: 4.166667vw;
}

.endedClass p {
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 18.7vw;
}

.endedClass span {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.mov {
    display: none;
}

.template {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    padding: 5vw;
}

.fitW {
    width: fit-content !important;
}

video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 1.388889vw;
}

.errorMessage {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    padding: 12px;

    background-color: #ff00553f;
    border-radius: 16px;
    border: 1px solid #ff0055c0;
}

@media (max-width: 530px) {
    .mov {
        display: block;
    }

    .goBack {
        width: 100%;
    }

    .goBack h2 {
        width: 100%;
        text-align: center;

        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 4.186047vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .goBack svg {
        width: 3.255814vw;
        height: 3.255814vw;
    }

    section {
        gap: 4.651163vw !important;
    }

    hr {
        display: block;
        background-color: #E3E3E9;
        border: 0;
        height: .232558vw;
    }

    .cover button svg {
        width: 7.674419vw;
        height: 14.709302vw;
    }

    .videoCont {
        height: 37.541667vw;
        border-radius: 4.651163vw;
    }

    .videoPlays {
        height: 53.023256vw;
    }

    .cover button {
        margin-left: -2.906977vw;
        margin-top: -8.65vw;
    }

    .information {
        flex-direction: column;
        margin-bottom: 18.604651vw;
    }

    .related {
        display: none;
    }

    .mainInfo h5:nth-child(3) {
        display: none;
    }

    .mainInfo,
    .asideInfo {
        width: 100%;
    }

    .row {
        flex-direction: row !important;
        justify-content: space-between;
    }

    h5 {
        font-size: 5.813953vw;
    }

    .mainInfo .moreInfo p {
        font-size: 2.790698vw;
        width: 46.511628vw;
    }

    .atribute {
        gap: 2.325581vw;
    }

    .atribute span,
    .atribute p {
        font-size: 3.488372vw;
        width: fit-content !important;
    }

    .atribute span {
        width: 27.906977vw !important;
    }

    .atribute svg {
        width: 3.488372vw;
        height: 3.488372vw;
    }

    .mainInfo .moreInfo {
        gap: 2.325581vw;
    }

    .classAtributes {
        gap: 2.325581vw;
    }

    .comentario {
        width: 100%;
    }

    .leaveComment {
        font-size: 3.488372vw;
        padding: 2.325581vw 4.651163vw;
        border-radius: 6.976744vw;
    }

    .user svg {
        width: 3.488372vw;
        height: 3.953488vw;
    }

    .comentario {
        padding: 3.488372vw;
        gap: 2.325581vw;
        border-radius: 6.976744vw;

    }

    .user {
        align-items: center;
        gap: 2.325581vw
    }

    .user p {
        font-size: 2.790698vw;
    }

    .comentarioInfo>span {
        font-size: 2.325581vw;
    }

    .comentario>p {
        font-size: 2.790698vw;
    }

    .comentarioCont {
        gap: 2.325581vw;
    }

    .respuesta {
        padding: 3.488372vw;
        gap: 2.325581vw;
        border-radius: 6.976744vw;
        width: 92%;
    }

    .respuesta>p {
        font-size: 2.790698vw;
    }

    .decoLine {
        width: 9.4%;
        left: -9.4%;
        border-radius: 0 0 0 4.651163vw;
    }

    .moreComments p {
        font-size: 2.790698vw;
    }

    .asideInfo {
        gap: 2.325581vw;
    }

    .answer p {
        font-size: 2.790698vw;
    }

    .like {
        width: 4.651163vw;
        height: 4.651163vw;
    }

    .like svg {
        width: 4.651163vw;
        height: 4.651163vw;
    }
}
</style>